import React from 'react';
import styled from 'styled-components';

import { Motion, spring, StaggeredMotion } from 'react-motion';

const AnimateContainer = styled.div`
    position: relative;
    max-width: 100%;
    /* width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column; */
`;

/**
 * -----------------------------------
 * Play with these values
 * -----------------------------------
 */
const startY = 10;
const startOpacity = 0;

// Lower damping and stiffness here will exaggerate the 
// Start of the sequence of animations
const initialStiffness = 400;
const initialDamping = 60;

// Lower damping and stiffness here will exaggerate the 
// End of the sequence of animations
const finalStiffness = 400;
const finalDamping = 60;
/* ---------------------------------- */

export const AppearTopStaggered = ({ children, WrapperElem, deltaY = startY }) => (
    <StaggeredMotion
        defaultStyles={[
            // Add more items here for more dots
            { y: deltaY, o: startOpacity },
            { y: deltaY, o: startOpacity },
            { y: deltaY, o: startOpacity },
            { y: deltaY, o: startOpacity },
            { y: deltaY, o: startOpacity }
        ]}
        styles={prevInterpolatedStyles => prevInterpolatedStyles.map((_, i) => {
            return i === 0
                // Initial stiffness and damping
                ? { y: spring(0, { stiffness: initialStiffness, damping: initialDamping }), o: spring(1) }
                // Final stiffness and damping 
                : {
                    y: spring(prevInterpolatedStyles[i - 1].y, { stiffness: finalStiffness, damping: finalDamping }),
                    o: spring(prevInterpolatedStyles[i - 1].o)
                };
        })}
    >
        {interpolatingStyles =>
            <React.Fragment>
                {interpolatingStyles.map((style, i) =>
                    <AnimateContainer key={`animate-${i}`}
                        style={{ marginBottom: 0, opacity: style.o, transform: `translateY(${style.y}%)` }}
                    >
                        {children[i]}
                    </AnimateContainer>
                )}
            </React.Fragment>
        }
    </StaggeredMotion>
);

const Animate = {
    AppearTopStaggered,
};
export default Animate;



// WEBPACK FOOTER //
// ./src/sc-ui/Animate.jsx